import fr from 'facet-rest';
import NullComponent from 'Components/UI/NullComponent';
import DateOrYearPickerWhatIf from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/whatIf';
import DefaultWithCloseAndRefreshStepOverride
  from 'Views/Page/Content/Modal/Layouts/DefaultWithCloseAndRefreshStep/MetaOverrideSet';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export default fr.metaOverride({ base: DefaultWithCloseAndRefreshStepOverride })
  .nameOverride('retirementDate', {
    _component: () => DateOrYearPickerWhatIf,
    _customProps: {
      startDateField: 'birthDate',
      yearLabel: 'Retirement Age',
    },
  }, overrideReadOnly)
  // This is marked as hidden on the backend via meta, but the frontend isn't respecting it :/ so I'm using this to make it not be hidden
  .nameOverride('birthDate', {
    _component: () => NullComponent,
  }, overrideReadOnly);
